import ErrorBoundary from '@shared/components/ErrorBoundaries/ErrorBoundary';
import LayoutContainer, { LayoutBodyType } from '@shared/components/Layout/LayoutContainer';
import SecureMsalRoute from '@shared/components/SecureMsalRoute/SecureMsalRoute';
import useAuthService from '@shared/hooks/useAuthService';
import { useFeatureFlags } from '@shared/hooks/useFeatureFlag';
import importRemote from '@shared/utilities/federation/loadremote';
import React, { Suspense } from 'react';
import legacyTheme from 'shared/theme/legacyCarmaxTheme';

import PageLoader from '../../components/PageLoading';

const BrokerageRemote = React.lazy(() =>
    importRemote({
        remoteName: 'Brokerage',
        scope: 'remote_brokerage',
        module: 'Landing',
        remoteUrlLocation: process.env.REMOTE_BROKERAGE,
    })
);

const BrokeragePage = () => {
    const { authService } = useAuthService();
    const flags = useFeatureFlags();

    return (
        <>
            <LayoutContainer
                hideSubHeader={false}
                includeFooter={true}
                layoutType={LayoutBodyType.FullWidth}
                theme={legacyTheme}>
                <ErrorBoundary>
                    <SecureMsalRoute>
                        {!flags?.brokerageShowTimedAuctions ? (
                            <div style={{ textAlign: 'center', padding: 10 }}>
                                You do not have access to this page.
                            </div>
                        ) : (
                            <Suspense fallback={<PageLoader label="brokerage-loading" />}>
                                <BrokerageRemote
                                    authService={authService}
                                    socketHost={process.env.BROKERAGE_SOCKET_HOST}
                                    restfulHost={process.env.BROKERAGE_RESTFUL_HOST}
                                />
                            </Suspense>
                        )}
                    </SecureMsalRoute>
                </ErrorBoundary>
            </LayoutContainer>
        </>
    );
};

export default BrokeragePage;
